import React, { Component } from 'react'
import gql from 'graphql-tag'
import { Link } from 'react-router-dom'
import { Mutation, withApollo } from 'react-apollo'
import { Container, Header, Form, Button } from 'semantic-ui-react'
import { TIPS_QUERY } from '../List'

class NewTip extends Component {
  state = {
    info: '',
  }

  componentDidMount = async () => {
    const { match } = this.props
    if (match.params && match.params.tipId) {
      this.props.client
        .query({ query: FIND_TIP, variables: { id: match.params.tipId } })
        .then(({ data }) => this.setState({ info: data.tip.info }))
    }
  }

  renderSaveButton = () => {
    const { info } = this.state
    const isEditing = this.props.match.params.tipId
    const mutation = isEditing ? UPDATE_TIP : CREATE_TIP
    const variables = isEditing
      ? { id: this.props.match.params.tipId, input: { info } }
      : { info }

    return (
      <Mutation
        mutation={mutation}
        refetchQueries={[
          { query: TIPS_QUERY, variables: { limit: 20, offset: 0 } },
        ]}
      >
        {(save, { loading }) => {
          return (
            <Button
              loading={loading}
              primary
              onClick={() =>
                save({ variables }).then(() => this.props.history.push('/tips'))
              }
            >
              Save
            </Button>
          )
        }}
      </Mutation>
    )
  }

  render() {
    return (
      <Container>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Header as="h1" content="Today's Tip" />
          <div>
            {this.renderSaveButton()}
            <Link to="/tips">
              <Button primary color="red">
                Cancel
              </Button>
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col s12">
            <label htmlFor="info">Tip Info</label>
            <Form.TextArea
              id="info"
              value={this.state.info}
              onChange={event => this.setState({ info: event.target.value })}
            />
          </div>
        </div>
      </Container>
    )
  }
}

const FIND_TIP = gql`
  query FindTip($id: ID!) {
    tip(id: $id) {
      id
      info
    }
  }
`

const CREATE_TIP = gql`
  mutation CreateTip($info: String!) {
    createTip(info: $info) {
      id
      info
    }
  }
`

const UPDATE_TIP = gql`
  mutation UpdateTip($id: ID!, $input: UpdateTipInput!) {
    updateTip(id: $id, input: $input) {
      id
      info
    }
  }
`

export default withApollo(NewTip)
